// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toggle {\n    vertical-align: middle;\n}\n\n.toggle-label-text {\n    margin-left: .5em;\n}\n\n.toggle-vert-align-outer {\n    display: table;\n    height: 100%;\n}\n\n.toggle-vert-align-inner {\n    display: table-cell;\n    vertical-align: middle;\n}\n", ""]);
// Exports
module.exports = exports;
